import request from '@/request'

export function update(dto) {
  return request({
    url: `/autoQAndA/update`,
    method: 'post',
    data: dto
  })
}

export function getData() {
  return request({
    url: `/autoQAndA/getData`,
    method: 'get'
  })
}

export function getByParentId(parentId) {
  return request({
    url: `/autoQAndA/getByParentId?parentId=${parentId}`,
    method: 'get'
  })
}

export function getCommonProblemByKeyword(dto) {
  return request({
    url: `/autoQAndA/getCommonProblemByKeyword`,
    method: 'post',
    data: dto
  })
}





// WEBPACK FOOTER //
// ./src/api/autoQAndA.js